import { uploadOrdersListData } from '../../_services/orders_list.service';

export const uploadOrdersListDataEvent = async (bytes, extension, type) => {
    let res = await uploadOrdersListData(bytes, extension, type);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}